<template>
  <div class="su-modal">
    <button
      class="su-modal__close m-btn"
      @click="closeModal"
    >
      <img
        src="/v2/school-university/close.svg"
        alt="cross"
        loading="lazy"
      >
    </button>

    <div
      class="su-modal__form"
      @keypress.enter="submit"
    >
      <h2 class="su-modal__form_title">
        {{ modalTitle }}
      </h2>

      <div class="su-modal__form_fields">
        <form-name-field
          ref="nameField"
          v-model="nameInput"
          class="su-modal__form_field"
          placeholder="как вас зовут?"
          round-border
        />

        <form-phone-field
          ref="phoneField"
          v-model="phoneInput"
          class="su-modal__form_field"
          :errors-list="submitError"
          :error="validForm === false"
          round-border
          placeholder="ваш номер телефона"
        />

        <form-email-field
          ref="emailField"
          v-model="emailInput"
          class="su-modal__form_field"
          :submit-error="submitError"
          round-border
          placeholder="ваша почта"
          @clearSubmitError="clearSubmitError"
        />
      </div>

      <!-- eslint-disable vue/multiline-html-element-content-newline -->
      <p class="su-modal__form_privacy">
        нажимая на кнопку, вы соглашаетесь
        с&nbsp;<nuxt-link
          to="/privacy"
          target="_blank"
        >условиями обработки данных</nuxt-link>
        в&nbsp;соответствии
        с&nbsp;<nuxt-link
          to="/privacy"
          target="_blank"
        >политикой конфиденциальности</nuxt-link>
      </p>
      <!-- eslint-enable -->

      <p
        v-if="!validForm"
        class="su-modal__form_error"
      >
        *упс, мы обнаружили ошибку, проверьте пожалуйста данные еще раз
      </p>

      <button
        class="m-btn su-modal__form_button"
        @click="submit"
      >
        оставить заявку
      </button>
    </div>

    <div
      class="su-modal__overlay"
      @click="closeModal"
    />
  </div>
</template>

<script>
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
  needToSendComments: true,
});

export default {
  name: 'SuFormModal',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],

  props: {
    modalType: {
      type: String,
      default: null,
    },
    modalComment: {
      type: String,
      default: null,
    },
  },
  computed: {
    modalTitle() {
      switch (this.modalType) {
        case 'simple':
          return 'поступайте в просто класс школьного университета';
        case 'it':
          return 'поступайте в it класс школьного университета';
        case 'cyber':
          return 'поступайте в кибер класс школьного университета';
        case 'business':
          return 'поступайте в бизнес класс школьного университета';
        case 'digital':
          return 'поступайте в digital класс школьного университета';
        case 'media':
          return 'поступайте в медиа класс школьного университета';
        case 'medical':
          return 'поступайте в мед. класс школьного университета';
        case '5-7':
          return 'поступайте в 5-7 класс школьного университета';
        case '8-9':
          return 'поступайте в 8-9 класс школьного университета';
        case '10-11':
          return 'поступайте в 10-11 класс школьного университета';
        default:
          return 'заявка на поступление в школьный университет';
      }
    },
    titleToSend() {
      return this.modalTitle;
    },
    commentsToSend() {
      if (this.modalComment) {
        return this.modalComment;
      }
      return '';
    },
  },

  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
    onSubmit() {
      this.$router.push('/thanks-shus');
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">

.su-modal {
  position: fixed;
  z-index: 15;
  inset: 0;
}

.su-modal__close {
  position: absolute;
  z-index: 2;
  top: calc(var(--scale) * 35);
  right: calc(var(--scale) * 45);
  width: calc(var(--scale) * 33);
  height: calc(var(--scale) * 33);
  border-radius: 50%;
  background-color: #ECEDF0;
  padding: calc(var(--scale) * 10);
  line-height: 0;

  @include media-down($size-tablet) {
    top: 1.7rem;
    right: 1.7rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.su-modal__form {
  width: calc(var(--scale) * 770);
  height: calc(var(--scale) * 780);
  padding: 2.5rem;
  display: flex;
  flex-direction: column;

  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  background-color: #FFFFFF;
  border-radius: calc(var(--scale) * 60);

  @include media-down($size-tablet) {
    width: calc(var(--scale) * 366);
    height: calc(var(--scale) * 540);
    padding: 2rem 1.6rem 0.8rem;
    border-radius: 3.2rem;
  }

  &_title {
    margin-bottom: 2.5rem;

    font-style: normal;
    font-weight: 500;
    font-size: 3rem;
    line-height: 110%;
    letter-spacing: -0.02em;
    color: #02120F;

    @include media-down($size-tablet) {
      margin-bottom: 2rem;
      font-size: 2.8rem;
      line-height: 95%;
    }
  }

  &_fields {
    display: grid;
    gap: calc(var(--scale) * 8);

    ::v-deep .su-modal__form_field {
      input {
        border: 1px solid #A7ABAC;
        height: calc(var(--scale) * 95);
        background-color: #FFFFFF;
        width: 100%;

        font-size: calc(var(--scale) * 26);
        color: #02120F;

        @include media-down($size-tablet) {
          height: 7rem;
          font-size: 1.8rem;
        }

        &::placeholder {
          color: #A7ABAC;
        }

        &:hover::placeholder {
          color: #02120F;
        }
      }

      &.has-error input {
        border-color: #ED131C;
      }

      .error-message,
      .phone-field__error {
        display: none;
      }
    }
  }

  &_privacy {
    margin-top: calc(var(--scale) * 20);

    font-style: normal;
    font-weight: 400;
    font-size: 1.25rem;
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-weight: 500;
      font-size: 1.4rem;
    }

    a {
      text-decoration-line: underline;
      color: #FF9C12;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &_error {
    margin-top: 0.75rem;

    font-style: normal;
    font-weight: 400;
    font-size: 1.25rem;
    line-height: 130%;
    color: #ED131C;

    @include media-down($size-tablet) {
      font-size: 1.4rem;
      font-weight: 500;
    }
  }

  &_button {
    margin-top: auto;
    height: calc(var(--scale) * 122);
    width: 100%;

    background-color: #FF5319;
    border-radius: 2.5rem;

    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      width: calc(100% + 1.6rem);
      margin-left: -0.8rem;
      height: 8rem;
      box-shadow: 1rem 1rem 5rem rgba(#071539, 0.1), 0.4rem 0.4rem 2rem rgba(#071539, 0.05);
      font-size: 1.8rem;
    }
  }
}

.su-modal__overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(#02120F, 0.3);
  backdrop-filter: blur(5px);
}

</style>
